// ----------------------------------------------------------------------------
// Template: Pages
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

//Scripts
import 'sections/header/header';
import 'sections/hero-banner/hero-banner';
import 'sections/intro-block/intro-block';
import 'sections/content-panel/content-panel';
import 'sections/icon-block/icon-block';
import 'sections/faqs/faqs';
import 'sections/jotform/jotform';
import 'sections/tabs/tabs';
import 'sections/anchor-links/anchor-links';
import 'sections/in-the-box/in-the-box';
import 'sections/collection-list/collection-list';
import 'sections/announcement-bar/announcement-bar';
import 'sections/content-cards/content-cards';
import 'sections/featured-collection/featured-collection';
import 'sections/blog-posts/blog-posts';
import 'sections/newsletter/newsletter';
import 'sections/page-header/page-header';
import 'sections/rich-text/rich-text';
import 'sections/reviews-toggle/reviews-toggle';
import 'sections/video-banner/video-block';
import 'sections/footer/footer';
import 'sections/manuals-list/manuals-list';
import 'sections/compatible-accessories/compatible-accessories';
import 'sections/accessories-collections-slider/accessories-collections-slider';
import 'sections/distributors-list/distributors-list';
import 'sections/video-instructions/video-instructions';
import 'sections/klaviyo-embed-form/klaviyo-embed-form';
import 'sections/video-image-banner/video-image-banner';

// Styles
import './_pages.scss';
